<template>
  <!-- 业务范围 -->
  <section class="bjzc-home-service">
    <h2 class="uk-text-center">{{ $t('sections.services') }}</h2>
    <div class="uk-container">
      <ServiceList />
    </div>
    <div class="more-btn-wrapper uk-text-center">
      <button class="bjzc-button" @click="more">{{ $t('messages.more') }}</button>
    </div>
  </section>
</template>

<script>
import ServiceList from './ServiceList.vue'
export default {
  name: '',
  components: { ServiceList },
  data() {
    return {}
  },
  created() {},
  methods: {
    more() {
      this.$router.push({ name: 'Service' })
    }
  }
}
</script>

<style lang="scss">
.bjzc-home-service {
  background-image: url('~@/assets/images/bg/section-1.png');
  background-position: 0% bottom;
  background-repeat: repeat-x;
}
</style>
